import React, {FC, ReactChild, useEffect, useState} from 'react';
import "../styles/slider.css";
import arrow from "../images/icons/ArrowMuted.svg";

interface SliderProps {
    className?: string;
    children?: ReactChild;
    interval?: number;
    id?: string;
}

const Slider : FC<SliderProps> = ({
  className,
  children,
  interval,
  id
}) => {

    
    const [current, setCurrent] = useState<number>(0);
    const [currentInterval, setCurrentInterval] = useState<any>(null);
    
    const randomId : string = (Math.random() + 1).toString(36).substring(2);

    useEffect(() => {
        if(interval){
            setInterval(() => updatePage(current+1), interval);
        }
        const parentId = id || `slider-${randomId}`;
        const childList = document.getElementById(parentId).children;
        //jsou tam i 2 šipky
        if(childList.length>3){
          for (let i = 1; i < childList.length-2; i++) {
            childList[i].classList.add("hidden");
          }
        }
        // return () => {
        //     if(currentInterval!==null){
        //         setCurrentInterval(null);
        //     }
        // }
    }, [interval])
    
    useEffect(() => {
        const parentElement = document.getElementById(`slider-${randomId}`);
        const length = parentElement?.children.length;
        if(length&&length>2){
            for(let i=1;i<length-2;i++){
                parentElement.children[i].classList.add("hidden");
            }
        }
    }, [children])

    function updatePage(nextPage:number):void{
      const parentId = id || `slider-${randomId}`;
        const parentElement = document.getElementById(parentId);
        let next : number = nextPage;
        const loopLength = parentElement?.children.length;
        if(parentElement&&loopLength&&loopLength>2){
            if(nextPage>=loopLength-2){
              next = 0;
            }else if(nextPage<0){
              next = loopLength-1;
            }else{
              next = nextPage;
            }
            parentElement.children[next].classList.toggle("hidden");
            parentElement.children[current].classList.toggle("hidden");
            setCurrent(next);
        }    
    }

    return (
      <div id={id ||`slider-${randomId}`} className={"slider "+(className?className:"")}>
        {children}
        <button
            className="btn prev btn-outline btn-muted inline"
            onClick={()=>updatePage(current-1)}
          >
            <img src={arrow} alt="arrow prev" />
          </button>
          <button
            className="btn next btn-outline btn-muted inline"
            onClick={()=>updatePage(current+1)}
          >
            <img src={arrow} alt="arrow next" />
          </button>
      </div>
    )
  }
  export default Slider;